import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  userSpaceName: '',
  userFullName: '',
  userEmail: '',
  userType: '',
  domain: '',
  isAuthrization: false
};

const whaleSpaceDataSlice = createSlice({
  name: 'whaleSpaceData',
  initialState,
  reducers: {
    setWhaleSpaceData: (state, action) => {
      state.userSpaceName = action.payload.userSpaceName;
      state.userFullName = action.payload.userFullName;
      state.userEmail = action.payload.userEmail;
      state.userType = action.payload.userType;
      state.domain = action.payload.userEmail.split('@').pop();
      state.isAuthrization = action.payload.isAuthrization;
    }
  }
});

export const { setWhaleSpaceData } = whaleSpaceDataSlice.actions;
export const useWhaleSpaceDataSliceSelector = createSelectorFn(whaleSpaceDataSlice);
export default whaleSpaceDataSlice;
